<template>
  <v-navigation-drawer
    v-if="getData"
    :class="barOpen ? 'white elevation-10' : 'white'"
    v-model="barOpen"
    hide-overlay
    right
    floating
    absolute
    :width="barOpen ? barSize : 0"
    disable-resize-watcher
  >
    <scroll-area>
      <template slot="header">
        <v-toolbar dense flat>
          <v-toolbar-title>
            <span v-if="getData.cls == 'folder'" class="body-2 uppercase">{{$t('create root element')}}</span>
            <span v-else class="body-2 uppercase">{{$t('create child element in')}} {{ getData.name }}</span>
          </v-toolbar-title>

          <v-layout fill-height justify-end>
            <v-tooltip v-if="showDoneButton" dark color="secondary" left>
              <v-btn v-if="showDoneButton" icon flat slot="activator" 
              :data-testid="$options.name + '__btn__' + 'submit'" 
              @click="submit(); $store.dispatch('setEditMode', false)">
                <svg-icon
                  :color="'primary'"
                  :name="'done'"
                  width="20"
                />
              </v-btn>
              <span>{{ $t('add') }}</span>
            </v-tooltip>

            <v-tooltip dark color="secondary" left>
              <v-btn icon flat slot="activator" 
              :data-testid="$options.name + '__btn__' + 'close'" 
              @click="close(); $store.dispatch('setEditMode', false)">
                <svg-icon
                  :color="'primary'"
                  :name="'close'"
                  width="20"
                />
              </v-btn>
              <span>{{ $t('cancel') }}</span>
            </v-tooltip>
          </v-layout>
        </v-toolbar>
      </template>

      <template slot="body">
        <v-container fluid fill-height ma-0 pa-0>
          <v-layout column fill-height justify-start>
            <v-layout fill-height>
              <v-flex xs6 pa-0>
                <v-layout column fill-height justify-start pt-1>
                  <!-- если defaultEntity.entity.type передан по дефолту, скрываем поле -->
                  <v-layout v-show="!defaultEntity.entity" shrink px-1 pb-1>
                    <v-flex xs4 shrink px-0>
                          
                      <v-text-field
                        :value="$t('entity')"
                        light
                        outline
                        flat
                        readonly
                        disabled
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >
                      </v-text-field>

                    </v-flex>

                    <v-flex xs8 shrink px-0>

                      <v-select
                        :data-testid="$options.name + '__text-field__' + 'current.entity'" 
                        v-model="current.entity"
                        light
                        ref="entity"
                        name="entity"
                        :items="getEntities"
                        item-text="name"
                        item-value="value"
                        outline
                        hide-details
                        class="white"
                        background-color="backgrey"
                        clearable

                      >
                        <template v-slot:item="{ item, index }">
                          <span>{{ $t(item.name) }}</span>
                        </template>
                        <template v-slot:selection="{ item, index }">
                            <span>{{ $t(item.name) }}</span>
                        </template>
                      </v-select>

                    </v-flex>

                  </v-layout>

                    <!-- если defaultEntity.type передан по дефолту, скрываем поле -->
                  <v-layout v-show="!defaultEntity.type" shrink v-if="!!current.entity && current.entity != 'cabinet' && current.entity != 'service' && current.entity != 'module'" px-1 pb-1>
                    <v-flex xs4 shrink px-0 >
                          
                      <v-text-field
                        :value="$t('entity type')"
                        light
                        outline
                        flat
                        readonly
                        disabled
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >

                      </v-text-field>

                    </v-flex>

                    <v-flex xs8 shrink px-0>

                      <v-select
                        :data-testid="$options.name + '__text-field__' + 'current.type'" 
                        v-model="current.type"
                        light
                        name="entity_type"
                        ref="current"
                        :items="getTypes"
                        item-text="id"
                        return-object
                        outline
                        hide-details
                        class="white"
                        background-color="backgrey"
                        clearable

                      >
                        <template v-slot:item="{ item, index }">
                          <span>{{ $t(item.id) }}</span>
                        </template>
                        <template v-slot:selection="{ item, index }">
                            <span>{{ $t(item.id) }}</span>
                        </template>
                      </v-select>

                    </v-flex>
                  </v-layout>

                  <v-layout shrink v-show="current.type && current.entity == 'device'" px-1 pb-1>

                    <v-flex xs4 shrink px-0>
                          
                      <v-text-field
                        :value="$t('vendor')"
                        light
                        outline
                        flat
                        readonly
                        disabled
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >

                      </v-text-field>

                    </v-flex>

                    <v-flex xs8 shrink px-0>

                      <v-select
                        :data-testid="$options.name + '__select__' + 'vendor'"
                        v-model="current.vendor"
                        light
                        name="vendor"
                        :items="getVendors"
                        :no-data-text="$t('no vendors')"
                        outline
                        hide-details
                        class="white"
                        background-color="backgrey"
                        clearable

                      >
                        <template v-slot:item="{ item, index }">
                          <span>{{ item }}</span>
                        </template>
                        <template v-slot:selection="{ item, index }">
                            <span>{{ item }}</span>
                        </template>
                      </v-select>

                    </v-flex>

                  </v-layout>

                  <v-layout shrink v-if="!!current.entity && current.entity == 'service'" px-1 pb-1>
                    <v-flex xs4 shrink px-0>
                          
                      <v-text-field
                        :value="$t('service_template')"
                        light
                        outline
                        flat
                        readonly
                        disabled
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >

                      </v-text-field>

                    </v-flex>

                    <v-flex xs8 shrink px-0>

                      <v-select
                        :data-testid="$options.name + '__select__' + 'current.template'" 
                        v-model="current.template"
                        light
                        name="service_template"
                        ref="current"
                        :items="getTemplates"
                        item-text="id"
                        return-object
                        outline
                        hide-details
                        class="white"
                        background-color="backgrey"
                        clearable

                      >
                        <template v-slot:item="{ item, index }">
                          <span>{{ $t(item.id) }}</span>
                        </template>
                        <template v-slot:selection="{ item, index }">
                            <span>{{ $t(item.id) }}</span>
                        </template>
                      </v-select>

                    </v-flex>
                  </v-layout>

                  <v-layout shrink v-if="current.type && current.entity == 'device'" px-1 pb-1>
                    <v-flex xs4 shrink px-0>
                          
                      <v-text-field
                        :value="$t('device model')"
                        light
                        outline
                        flat
                        readonly
                        disabled
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >

                      </v-text-field>

                    </v-flex>

                    <v-flex xs8 shrink px-0>

                      <v-select
                        :data-testid="$options.name + '__select__' + 'current.model'" 
                        v-model="current.model"
                        light
                        name="device model"
                        :items="getModels"
                        item-text="id"
                        return-object
                        outline
                        hide-details
                        class="white"
                        background-color="backgrey"
                        clearable

                      >
                        <template v-slot:item="{ item, index }">
                          <span>{{ $t(item.id) }}</span>
                        </template>
                        <template v-slot:selection="{ item, index }">
                            <span>{{ $t(item.id) }}</span>
                        </template>
                      </v-select>

                    </v-flex>
                  </v-layout>

                  <v-expansion-panel
                    light
                    v-if="current.type && current.entity == 'device' && current.model"
                    expand
                    v-model="deviceTemplatePanelOpen"
                    class="my-2 px-1"
                  >
                    <v-expansion-panel-content>
                      <template v-slot:header>
                        <v-layout justify-center>
                          <span class="body-2 text-uppercase">{{$t('template information')}}</span>
                        </v-layout>
                      </template>
                      <v-card>
                        <v-flex v-for="(field, i) in getDeviceTemplateFields" :key="'deviceTemplateField_' + i" px-2>
                          <v-layout v-if="field != 'children' && field != 'bridges' && field != 'deviceType' && field != 'cls' && field != 'refs' && field != 'id' && field.charAt(0) != '$'" justify-space-between>
                            <span class="body-2 text-uppercase">{{$t(field) + ':  '}}  </span>
                            <span class="body-2 text-uppercase pl-3">{{current.model[field]}}</span>
                          </v-layout>
                        </v-flex>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-layout column fill-height justify-start>
                    <v-flex v-if="current.model && current.entity == 'device'" pa-2>
                      <div :style="`background-size: contain; height: 100%; width: 100%; backgroundImage: url(${this.getBackground(this.current.model.id, 'device')})`"></div>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-flex>

              <v-flex xs6 pa-0 >
                <v-layout v-if="!current.model || current.entity == 'location' || current.entity == 'cabinet'" fill-height justify-start>
                  <scroll-area>
                    <template slot="body">
                      <v-layout column fill-height justify-start pt-1>
                        <v-form ref="location_form" style="height: 100%">
                          <v-flex shrink v-if="getFields" v-for="(field, index) in getFields" :key="'text' + field.name">
                            <v-layout shrink v-if="field.show == 'true' && field.type == 'text' && field.name != 'template' && field.name != 'type'" px-1 pb-1>
                              <v-flex xs4 shrink px-0>
                                    
                                <v-text-field
                                  :value="$t(field.name)"
                                  light
                                  outline
                                  flat
                                  readonly
                                  disabled
                                  class="backgrey"
                                  hide-details
                                  :rows="1"
                                  color="white"
                                >

                                </v-text-field>

                              </v-flex>

                              <v-flex xs8 shrink px-0>
                                <v-text-field
                                  :data-testid="$options.name + '__text-field__' + field.name" 
                                  v-model="current.obj[field.name]"
                                  :rules="field.required ? [value => !!value || $t('field must be filled'), () => setErrorMessage(field.name, current.obj[field.name], 'must be filled')] : []"
                                  light
                                  auto-grow
                                  outline
                                  class="white"
                                  persistent-hint
                                  hide-details
                                  :rows="1"
                                  color="accent"
                                >
                                </v-text-field>

                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex shrink v-if="getFields" v-for="(field, name) in getFields" :key="name + 'select'">
                            <v-layout shrink v-if="field.show == 'true' && (field.type == 'select' || field.type == 'select_enum')" px-1 pb-1>
                              <v-flex xs4 shrink px-0>
                                    
                                <v-text-field
                                  :value="$t(field.name)"
                                  light
                                  outline
                                  flat
                                  readonly
                                  disabled
                                  class="backgrey"
                                  hide-details
                                  :rows="1"
                                  color="white"
                                >
                                </v-text-field>

                              </v-flex>
                              <v-flex xs8 shrink px-0>

                                <v-select
                                  :data-testid="$options.name + '__select__' + field.name" 
                                  v-model="current.obj[field.name]"
                                  light
                                  :items="getItems[field.cls]"
                                  :item-text="field.type == 'select' ? 'name' : 'value'"
                                  :item-value="field.type == 'select' ? '$id' : 'id'"
                                  :rules="field.required ? [value => !!value || $t('field must be filled'), () => setErrorMessage(field.name, current.obj[field.name], 'must be filled')] : []"
                                  validate-on-blur
                                  outline
                                  hide-details
                                  class="white"
                                  background-color="backgrey"
                                  clearable

                                >
                                  <template v-slot:item="{ item, index }">
                                      <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                                  </template>
                                  <template v-slot:selection="{ item, index }">
                                      <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                                  </template>
                                </v-select>

                              </v-flex>

                            </v-layout>
                          </v-flex>
                        </v-form>
                      </v-layout>
                    </template>
                  </scroll-area>
                </v-layout>

                <v-layout column v-if="current.model && (current.entity == 'device' || current.entity == 'module')" fill-height justify-start>
                  <component
                    is="form-fields"
                    ref="new-device-form"
                    :defaultEntity="defaultEntity"
                    :data="current.model"
                    :type="current.entity"
                    @update="() => {this.$emit('update')}"
                  />
                </v-layout>

              </v-flex>
            </v-layout>

            <v-layout column fill-height v-if="current.type && current.entity == 'location'">
              <v-flex shrink>
                <v-checkbox light :label="$t('set coordinates ')" 
                :data-testid="$options.name + '__checkbox__' + 'set coordinates '" 
                v-model="setMap" value="value"></v-checkbox>
              </v-flex>

              <component
                v-if="setMap"
                :is="'location-map'"
                :data="data"
                :editMapCenter="true"
                @change="(payload) => onCoordsChange(payload)"
                edit
              />

              <file-image
                v-if="!setMap"
                ref="file-image-component"
                :image="getPreview"
                edit
                @select="(payload) => {onPlanAdd(payload)}"
              />

            </v-layout>
          </v-layout>
        </v-container>
      </template>
    </scroll-area>
  </v-navigation-drawer>
</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import fileImage from '@/nms/components/partials/file-image.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'
import LocationMap from '@/nms/components/map/map.vue'
import FormFields from '@/nms/pages/device/form/form-device-bar-fields.vue'

// Типы
interface FieldItem {
  name?: string
  default?: any
  value?: any
  group?: string
  type?: string
  [key: string]: any
}

interface ModelEntity {
  types: any[]
  type?: string
  fields?: any[]
  vendors?: any[]
  models?: any[]
  vendor?: string
  model?: string
  templates?: any[]
}

interface ModelData {
  location: ModelEntity
  service: ModelEntity & { templates: any[] }
  cabinet: ModelEntity
  device: ModelEntity & { models: any[]; vendors: any[]; model: string; vendor: string }
  module: ModelEntity & { models: any[]; vendors: any[]; model: string; vendor: string }
}

interface CurrentState {
  entity: string
  type: any | null
  vendor: any | null
  model: any | null
  fields: Record<string, FieldItem>
  obj: Record<string, any>
  items: Record<string, any>
  image: any | null
  name: string | null
  template?: any
  bridges?: Record<string, any>
}

interface StateMessages {
  error: Record<string, string>
}

interface StateData {
  messages: StateMessages
}

interface DialogState {
  upload: {
    files: any[]
    show: boolean
  }
}

interface ComponentData {
  dataOnLoadId: string | null
  barOpen: boolean
  barSize: number
  cabinetTemplatePanelOpen: boolean[]
  deviceTemplatePanelOpen: boolean[]
  showDoneButton: boolean
  entity: {
    type: Record<string, any>
    types: Array<{ value: string; name: string }>
  }
  model: ModelData
  area: string
  setMap: boolean
  center: [number, number]
  current: CurrentState
  state: StateData
  preview: boolean
  meta: Record<string, any>
  files: any[]
  dialog: DialogState
}

interface DefaultEntity {
  entity?: string
  type?: any
  model?: any
  name?: string
  [key: string]: any
}

interface LocationData {
  $id?: string
  coordinates?: { latitude: number; longitude: number }
  latitude?: number
  longitude?: number
  [key: string]: any
}

interface CoordsPayload {
  latitude: number
  longitude: number
}

interface SubmitData {
  [key: string]: any
}

export default Vue.extend({
  name: 'CREATE_LOCATION_BAR',

  components: {
    scrollArea,
    fileImage,
    svgIcon,
    LocationMap,
    FormFields
  },

  props: {
    open: {
      type: Boolean,
      default: () => false
    },
    data: {
      type: Object as () => LocationData,
      default: () => ({})
    },
    defaultEntity: {
      type: Object as () => DefaultEntity,
      default: () => ({})
    },
    onlyEmit: {
      type: Boolean,
      default: () => false
    },
  },

  data(): ComponentData {
    return {
      dataOnLoadId: null,
      barOpen: false,
      barSize: 0,
      cabinetTemplatePanelOpen: [true],
      deviceTemplatePanelOpen: [true],
      showDoneButton: false,
      entity: {
        type: {},
      },
      model: {
        location: { types: [], type: '', fields: [] },
        service: { templates: [], types: [], type: '', fields: [] },
        cabinet: { types: [], type: '', fields: [] },
        device: { types: [], type: '', vendors: [], models: [], model: '', vendor: '', fields: [] },
        module: { types: [], type: '', vendors: [], models: [], model: '', vendor: '', fields: [] },
      },
      area: 'plan',
      setMap: false,
      center: [55.755919, 37.617589],
      current: {
        entity: '',
        type: null,
        model: null,
        vendor: null,
        fields: {},
        obj: {},
        items: {},
        image: null,
        name: null
      },
      state: {
        messages: { error: {} }
      },
      preview: false,
      meta: {},
      files: [],
      dialog: {
        upload: { files: [], show: false }
      },
    }
  },

  computed: {
    getData(): LocationData {
      return this.data
    },

    getEntities(): any[] {
      let entities = this.$store.getters.getLocationNails.create.entity.types

      if (this.getData.cls == 'folder') {
        entities = [
            { value: 'service', name: 'Сервис' },
            { value: 'location', name: 'Локация' }
          ]
      }
      return entities
    },

    getTypes(): any[] {
      if (this.model[this.current.entity as keyof ModelData]) {
        return this.current.entity ? this.model[this.current.entity as keyof ModelData].types : []
      }
      return []
    },

    getTemplates(): any[] {
      return this.model.service.templates || []
    },

    getDeviceTemplateFields(): string[] {
      return Object.keys(this.current.model || {})
    },

    getVendors(): any[] {
      return this.current.entity ? this.model[this.current.entity as keyof ModelData].vendors || [] : []
    },

    getModels(): any[] {
      let models = this.current.vendor ? this.model[this.current.entity as keyof ModelData].models.filter(device => {
        return device.manufacturer == this.current.vendor
      }) : this.model[this.current.entity as keyof ModelData].models
      return models
      // return this.current.entity ? this.model[this.current.entity as keyof ModelData].models || [] : []
    },

    getFields(): Record<string, FieldItem> {
      return this.current.fields
    },

    getItems(): Record<string, any> {
      return this.current.items
    },

    getPreview(): any[] {
      if (this.preview) {
        return [{ url: this.preview }]
      } else {
        return this.getPlan
      }
    },

    getPlan(): any[] {
      if (!this.files.length) return []
      return this.files.filter(file => file.data?.description === 'image_$')
    },
  },

  watch: {
    open: {
      handler(newVal: boolean): void {
        if (this.$parent.$refs?.['barWrapper']) {
          this.barSize = (this.$parent.$refs['barWrapper'] as HTMLElement).clientWidth
        } else if (this.$parent.$parent?.$refs?.['bar_wrapper']) {
          this.barSize = (this.$parent.$parent.$refs['bar_wrapper'] as HTMLElement).clientWidth
        }
        console.log('WATCH', this.$options.name, 'open newVal', newVal)
        console.log('WATCH', this.$options.name, 'open barSize', this.barSize)
        if (newVal) {
          this.reset()
          this.setup('WATCH open')
        }
        this.barOpen = newVal
        console.log('WATCH', this.$options.name, 'this.barOpen', this.barOpen)
      },
      deep: true
    },
    data: {
      handler(): void {
        if (this.open) {
          this.reset()
          this.setup('WATCH data')
        }
      },
      deep: true
    },
    'current.entity': {
      async handler(newVal: string): Promise<void> {
        // console.log('WATCH', this.$options.name, 'current.entity', newVal)
        if (!newVal) return
        
        if (!this.defaultEntity.type) {
          this.$set(this.current, 'type', null)
        }
        this.$set(this.current, 'fields', {})
        this.$set(this.current, 'obj', {})
        this.$set(this.current, 'model', null)
        this.cabinetTemplatePanelOpen = [true]
        this.deviceTemplatePanelOpen = [true]

        if (newVal === 'device') {
          const entityTypes = await this.$bridge.getEnum('devicetype')
          if (entityTypes) {
            const types = this.$merge(this.model.device.types, entityTypes)
            this.$set(this.model.device, 'types', types)
          }
          if (!this.current.model) {
            this.showDoneButton = false
          }
          return
        }

        if (newVal === 'location') {
          const entityTypes = await this.$bridge.getEnum('location')
          if (entityTypes) {
            this.$set(this.model.location, 'types', entityTypes)
          }
          if (!this.current.type) {
            this.showDoneButton = false
          }
          return
        }

        if (newVal === 'service') {
          this.model.service.templates = await this.$bridge.getTemplates('service')
          return
        }

        if (newVal === 'cabinet') {
          this.$set(this.current, 'type', { id: 'default' })
          return
        }

        if (newVal === 'module') {
          this.model.module.types = await this.$bridge.getTemplates('module')
          if (!this.current.model) {
            this.showDoneButton = false
          }
          return
        }

        try {
          const entityTemplates = await this.$bridge.getTemplates(newVal)
          if (entityTemplates) {
            this.model[newVal as keyof ModelData].types = this.$merge(this.model[newVal as keyof ModelData].types, entityTemplates)
          }
        } catch (err) {
          console.error('CATCH', 'WATCH', 'entity_templates', newVal, err)
        }
      },
      deep: true
    },
    'current.type': {
      async handler(newVal: any): Promise<void> {
        // console.log('WATCH', this.$options.name, 'current.type', newVal)
        if (!newVal) return
        
        this.current.fields = {}
        this.current.model = null
        this.setMap = false
        this.cabinetTemplatePanelOpen = [true]
        this.deviceTemplatePanelOpen = [true]
        
        if (this.current.entity === 'cabinet') {
          this.loadMeta('cabinet')
          this.showDoneButton = true
        }
        if (this.current.entity === 'location') {
          this.loadMeta('location', newVal.id)
          this.showDoneButton = true
        }
        if (this.current.entity === 'device') {
          let models = await this.$bridge.getTemplates('device', { device_type: newVal.id })


          if (models) {
            // this.model.device.models = []
            // this.model.device.vendors = []
            let models_ = []
            let vendors_ = []
            models.forEach(device => {
              models_.push(device)
              // console.log('models device', device)
              if (device.manufacturer && !vendors_.includes(device.manufacturer)) {
                vendors_.push(device.manufacturer)
              }
            })
            // console.log('vendors', vendors_)
            // console.log('vendors!!!', this.model[this.current.entity as keyof ModelData].vendors)
            this.$set(this.model.device, 'models', models_)
            this.$set(this.model.device, 'vendors', vendors_)

            
          } else {
            console.log(this.$options.name, 'watch current.type', 'smth wrong', models)
          }



          // this.model.device.models = this.current.vendor ? models.filter(device => {
          //   return this.current.vendor.includes(device.manufacturer || '')
          // }) : models

          // this.model.device.models = await this.$bridge.getTemplates('device', { device_type: newVal.id })
        }
      }
    },
    'current.template': {
      async handler(newVal: any): Promise<void> {
        // console.log('WATCH', this.$options.name, 'current.template', newVal)
        if (!newVal) return
        
        this.current.fields = {}
        this.loadMeta('service', newVal.id)
        this.showDoneButton = true
      }
    },
    'current.model': {
      async handler(newVal: any): Promise<void> {
        // console.log('WATCH', this.$options.name, 'current.model', newVal)
        if (!this.current.model) return
        
        this.current.fields = {}
        this.loadMeta('device')
        this.showDoneButton = true
      }
    },
  },

  created(): void {
    if (this.open) {
      this.setup('created')
    }
  },

  mounted(): void {
    document.addEventListener('keyup', this.closeOnESC)
    window.addEventListener('resize', this.resizeHandler)
  },

  updated(): void {
    if (this.open) {
      this.barOpen = this.open
    }
  },

  beforeDestroy(): void {
    document.removeEventListener('keyup', this.closeOnESC)
    window.removeEventListener('resize', this.resizeHandler)
  },

  methods: {
    setup(caller: string): void {
      console.log(this.$options.name, 'setup', 'getData', this.getData)
      if (this.getData?.$id) {
        // console.log(this.$options.name, 'setup', 'caller', caller)
        // console.log(this.$options.name, 'setup', 'this.dataOnLoadId', this.dataOnLoadId)
        // console.log(this.$options.name, 'setup', 'this.getData.$id', this.getData.$id)
        if (this.dataOnLoadId === this.getData.$id) return
        this.checkParentCoords()
        if (Object.keys(this.defaultEntity).length) {
          this.setDefaults()
        }
      } else if (Object.keys(this.defaultEntity).length) {
        console.log(this.$options.name, 'setup', 'caller', caller)
        this.setDefaults()
      }
    },

    setDefaults(): void {
      Object.keys(this.current).forEach(key => {
        if (this.defaultEntity[key]) {
          this.$set(this.current, key, this.defaultEntity[key])
        }
      })
      console.log(this.$options.name, 'setDefaults', 'this.defaultEntity', this.defaultEntity)
      console.log(this.$options.name, 'setDefaults', 'this.current', this.current)
    },

    checkParentCoords(): void {
      // console.log(this.$options.name, 'checkParentCoords', 'this.data', this.data)
      if (this.data.coordinates) {
        this.center[0] = this.data.coordinates.latitude
        this.center[1] = this.data.coordinates.longitude
      } else if (this.data.latitude && this.data.longitude) {
        this.center[0] = this.data.latitude
        this.center[1] = this.data.longitude
      }
    },

    onCoordsChange(payload: CoordsPayload): void {
      const coords = {
        latitude: payload.latitude,
        longitude: payload.longitude
      }
      this.$set(this.current.obj, 'coordinates', coords)
    },

    async loadMeta(cls: string, type?: string): Promise<void> {

      this.area = 'plan'
      this.current.fields = {}
      this.current.obj = {}
      this.current.items = []
      
      try {
        this.setLoader('loadMeta', true)
        this.meta = await this.$loadMeta(cls, type)
        
        if (this.meta) {
          const model = await this.$prepareMeta(this.meta, this.$options.name)
          if (model) {
            this.$set(this.model[this.current.entity as keyof ModelData], 'fields', [])
            this.$set(this.current, 'fields', model.fields)
            this.$set(this.current, 'obj', model.obj)
            this.$set(this.current, 'items', model.items)
            if (model.bridges) {
              this.$set(this.current, 'bridges', model.bridges)
            }
            
            this.meta.fields?.forEach((field: FieldItem) => {
              if (field.name === 'coordinates') {
                this.area = 'map'
                const coords = {
                  latitude: this.center[0],
                  longitude: this.center[1]
                }
                this.$set(this.current.obj, 'coordinates', coords)
              }
            })
            this.prepareData()
          }
        }
        this.setLoader('loadMeta', false)
      } catch (err) {
        console.error('CATCH', this.$options.name, 'loadMeta', err)
        this.setLoader('loadMeta', false)
      }
    },

    async prepareData(): Promise<void> {
      const fields = Object.keys(this.current.fields)
      
      if (this.current.type && this.current.entity) {
        fields.forEach(name => {
          if (name === 'name' && this.current.entity !== 'device' && this.current.entity !== 'module') {
            const l = this.current.type.id
            const generatedName = `${l}_$${Math.round(Math.random() * 10000000000)}`
            this.$set(this.current.obj, 'name', generatedName)
          }
          if (this.current.fields[name]?.default && !this.current.fields[name]?.value) {
            if (this.current.bridges) {
              if (Object.keys(this.current.bridges).some(bridge => bridge === this.current.fields[name].group)) {
                this.$set(this.current.obj, name, this.current.fields[name].default)
              }
            }
          }
        })
        console.log(this.$options.name, 'prepareData', 'obj', this.current.obj)
      }
    },

    async getEnum(cls: string): Promise<any[] | undefined> {
      try {
        const items = await this.$bridge.getEnum(cls)
        return items
      } catch (error) {
        console.error('CATCH', this.$options.name, 'getEnum', 'SMTH WRONG', error)
        return undefined
      }
    },

    getBackground(data: string, cls: string): string | undefined {
      let path
      if (cls === 'device') {
        path = this.$bridge.getImageLinkByTemplate('device', data, 'front')
      }
      if (cls === 'cabinet') {
        path = this.$bridge.getImageLinkByTemplate('cabinet', data, 'image')
      }
      if (path) {
        return path.replace(/\s/g, '%20')
      }
      return undefined
    },

    onPlanAdd(e: Event): void {
      const target = e.target as HTMLInputElement
      if (!target.files?.length) return
      
      this.preview = window.URL.createObjectURL(target.files[0])
      const file = target.files[0]
      file.data = this.$merge({}, { description: 'image_$' })
      this.$set(this.current, 'image', file)
    },

    checkForm(name: string): boolean {
      const ref = this.$refs[name] as any
      return ref ? ref.validateForm() : false
    },

    setErrorMessage(name: string, value: any, err: string): boolean {
      if (name && err) {
        if (name === 'name') {
          if (value && String(value).length > 35) {
            this.$set(this.state.messages.error, name, `${this.$getTranslate(err)} 35`)
          }
          if (!value) {
            this.$set(this.state.messages.error, name, `${this.$getTranslate('field')} ${this.$getTranslate(name)} ${this.$getTranslate(err)}`)
          }
        } else {
          if (!value) {
            this.$set(this.state.messages.error, name, `${this.$getTranslate('field')} ${this.$getTranslate(name)} ${this.$getTranslate(err)}`)
          }
        }
        return false
      }
      return true
    },

    async submit(): Promise<void> {
      if (this.$store.state.auth.lock) return
      
      this.$set(this.state.messages, 'error', {})
      let valid: any
      
      if (this.current.entity === 'device' || this.current.entity === 'module') {
        valid = this.checkForm('new-device-form')
        if (!valid) {
          this.$dialog.notify.error(this.$getTranslate(valid), { timeout: 1000 })
          return
        }
      } else {
        const formRef = this.$refs['location_form'] as any
        valid = formRef?.validate() || false
        if (!valid) {
          if (Object.keys(this.state.messages.error).length) {
            Object.keys(this.state.messages.error).forEach(message => {
              this.$dialog.notify.error(this.state.messages.error[message], { timeout: 1000 })
            })
          } else {
            this.$dialog.notify.error(this.$getTranslate('error'), { timeout: 1000 })
          }
          return
        }
      }

      let parentId = this.getData.$id
      if (this.current.entity === 'service') {
        const servicesParent = await this.$bridge.getByPath('/logical/services')  
        if(servicesParent?.$id) {
          parentId = servicesParent.$id
        }
      }
      
      const parent$ = await this.$bridge.getObjectById(parentId)
      const data_$: SubmitData = Object.assign({}, valid.valid)

      if (this.current.entity === 'service') {
        data_$.template = this.current.template?.id
      } else {
        data_$.template = this.current.model ? this.current.model.id : this.current.type?.id
        data_$.mount = this.current.obj.mount || 'front'
      }

      const fields = Object.keys(this.current.obj)
      fields.forEach(field => {
        data_$[field] = this.current.obj[field]
      })

      const data$: SubmitData = {}
      Object.keys(data_$).forEach(key => {
        data$[key] = data_$[key]
      })

      if (this.files.length) {
        data$.files = [...this.files]
      }

      if (this.current.type) {
        data$.type = this.current.type.id
      }

      if (this.current.image) {
        if (!data$.files) data$.files = []
        data$.files.push(this.current.image)
      }

      if (this.onlyEmit) {
        const val = {
          entity: this.current.entity,
          data: data$
        }
        this.$emit('submit', val)
        this.close()
        return
      }

      try {
        this.setLoader('submitCreateLocation', true)
        const c = await parent$.createChild(this.current.entity, data$)
        
        if (c) {
          await this.$store.dispatch('updateObject', { $id: c.$id })
          this.$bridge.litePolling(c.$id)
          this.$emit('update')
          this.$dialog.notify.success('Успешно создано', { timeout: 5000 })
          this.reset()
          this.setLoader('submitCreateLocation', false)
          this.$store.state.auth.lock = false
        } else {
          this.$dialog.notify.error('Элемент не обновлён', { timeout: 5000 })
          this.setLoader('submitCreateLocation', false)
          this.$store.state.auth.lock = false
        }
      } catch (err) {
        console.error('CATCH', this.$options.name, 'submit', err)
        this.$errorHandler(err)
        this.setLoader('submitCreateLocation', false)
        this.$store.state.auth.lock = false
      }
    },

    closeOnESC(e: KeyboardEvent): void {
      if (e.which === 27 || e.keyCode === 27) {
        e.stopPropagation()
      }
    },

    resizeHandler(): void {
      if (this.$parent.$refs?.['barWrapper']) {
        this.barSize = (this.$parent.$refs['barWrapper'] as HTMLElement).clientWidth
      }
    },

    close(): void {
      this.reset()
      this.$emit('close')
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    reset(): void {
      this.cabinetTemplatePanelOpen = [true]
      this.deviceTemplatePanelOpen = [true]
      this.showDoneButton = false
      this.model = {
        location: { types: [], type: '', fields: [] },
        service: { templates: [], types: [], type: '', fields: [] },
        cabinet: { types: [], type: '', fields: [] },
        device: { types: [], type: '', vendors: [], models: [], model: '', vendor: '', fields: [] },
        module: { types: [], type: '', vendors: [], models: [], model: '', vendor: '', fields: [] },
      }
      this.state = { messages: { error: {} } }
      this.current = {
        entity: '',
        type: null,
        model: null,
        vendor: null,
        fields: {},
        obj: {},
        items: {},
        image: null,
        name: null,
      }
      this.files = []
      this.area = 'plan'
      this.setMap = false
    },
  },
})
</script>

<style scoped>

</style>
